import { render, staticRenderFns } from "./RadioButtonWrapper.vue?vue&type=template&id=6f8734b1&scoped=true&"
import script from "./RadioButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./RadioButtonWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonWrapper.vue?vue&type=style&index=0&id=6f8734b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8734b1",
  null
  
)

export default component.exports